import React, { useState } from 'react';
import classNames from 'classnames';
import Intl from '@fx-ui/intl';
import { IconFont } from '~/components';
import { Button, Input, Message, Tooltip } from '@fx-ui/fine-design';
import { getUrlSearchParams, insertURLQuery, post, redirect } from '~/utils';
import { API, ECode, URL_PARAMETER } from '~/constants';

interface CorpUrlLoginProps {
    className?: string;
}

/**
 * 独享版企业登录
 */
const CorpUrlLogin: React.FC<CorpUrlLoginProps> = (props) => {
    const { className } = props;
    const [corpUrl, setCorpUrl] = useState<string>('');

    return (
        <div className={classNames('fx-corp-url-login', className)}>
            <div className="corp-url-container">
                <div className="corp-url-title">
                    {Intl.get('fxp.base.workspace.login.corp_login.ttl')}
                </div>
                <div className="corp-url-tip">
                    {Intl.get('fxp.base.workspace.login.enter_tenant_id.tip')}
                    <Tooltip
                        effect="light"
                        placement="top-left"
                        overlayStyle={{
                            maxWidth: 280
                        }}
                        content={Intl.get('fxp.base.workspace.login.get_tenant_id.tip')}
                    >
                        <IconFont className="tip-icon" type="help" />
                    </Tooltip>
                </div>
                <div className="corp-url-content">
                    <Input
                        className="corp-url-input"
                        placeholder={Intl.get('fxp.base.workspace.login.tenant_id.tip')}
                        value={corpUrl}
                        onChange={setCorpUrl}
                    />
                </div>
                <Button
                    block
                    type="primary"
                    loadingWhenClick
                    onClick={() => {
                        if (!corpUrl) {
                            Message.warning(
                                Intl.get('fxp.base.workspace.login.enter_tenant_id.tip')
                            );
                            return;
                        }
                        return post<{ tenant_id: string; current_corp_url: string }>(
                            API.login_page.verify_corp_url,
                            { corp_url: corpUrl },
                            {
                                customHandleErrorCodes: [
                                    ECode.TENANT_NOT_FOUND,
                                    ECode.EXCEED_FREQUENCY_LIMIT
                                ]
                            }
                        )
                            .then((res) => {
                                const tenantId = res.data.tenant_id;
                                if (tenantId) {
                                    const targetUrl = (() => {
                                        const customLoginUrl = res.data.current_corp_url;
                                        const redirectUri = getUrlSearchParams(
                                            URL_PARAMETER.REDIRECT_URI
                                        );
                                        if (redirectUri) {
                                            return insertURLQuery(customLoginUrl, [
                                                {
                                                    key: URL_PARAMETER.REDIRECT_URI,
                                                    value: encodeURIComponent(redirectUri)
                                                }
                                            ]);
                                        }

                                        return customLoginUrl;
                                    })();
                                    return redirect(targetUrl);
                                }
                                Message.warning(
                                    Intl.get('fxp.base.workspace.login.corp_account_unavail.tip')
                                );
                            })
                            .catch((err) => {
                                const errCode = err.response?.data?.code;
                                switch (errCode) {
                                    case ECode.TENANT_NOT_FOUND:
                                        Message.warning(
                                            Intl.get(
                                                'fxp.base.workspace.login.corp_account_unavail.tip'
                                            )
                                        );
                                        break;
                                    case ECode.EXCEED_FREQUENCY_LIMIT:
                                        Message.warning(
                                            Intl.get(
                                                'fxp.base.workspace.login.too_many_submissions.tip'
                                            )
                                        );
                                        break;
                                    default:
                                        return;
                                }
                            });
                    }}
                >
                    {Intl.get('nextStep')}
                </Button>
            </div>
        </div>
    );
};

export default CorpUrlLogin;
